import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { getFilterPanelProps } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields, getGeoFilterFields } from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';
import type { useZonalStatementFilters } from '../hooks/useZonalStatementFilters';

interface ZonalStatementFilterPanelProps {
  controller: ReturnType<typeof useZonalStatementFilters>;
}

export function ZonalStatementFilterPanel({ controller }: ZonalStatementFilterPanelProps) {
  const { filterValues } = controller;

  const { divisions, districts } = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: undefined,
  });

  const geoFields = getGeoFilterFields(filterValues, {
    divisions,
    districts,
    thanas: undefined,
  }).filter((field) => field.key !== FILTER_KEYS.thanaId);

  return (
    <AdvancedFilterPanel
      fields={[...getDateFromToFilterFields(), ...geoFields]}
      {...getFilterPanelProps(controller)}
    />
  );
}
